var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.407,
    height: 30.235,
    viewBox: "0 0 25.407 30.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-apple",
    "data-name": "Icon awesome-apple",
    d: "M21.524,18.227A6.3,6.3,0,0,1,24.9,12.5a7.252,7.252,0,0,0-5.717-3.011c-2.4-.189-5.015,1.4-5.974,1.4-1.013,0-3.335-1.33-5.157-1.33-3.767.061-7.769,3-7.769,8.991a16.824,16.824,0,0,0,.972,5.481c.864,2.477,3.983,8.552,7.236,8.451,1.7-.041,2.9-1.208,5.117-1.208,2.147,0,3.26,1.208,5.157,1.208,3.281-.047,6.1-5.569,6.926-8.053a6.691,6.691,0,0,1-4.165-6.2ZM17.7,7.144a6.358,6.358,0,0,0,1.62-4.894A7.157,7.157,0,0,0,14.74,4.606a6.457,6.457,0,0,0-1.728,4.853A5.669,5.669,0,0,0,17.7,7.144Z",
    transform: "translate(-0.281 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/appleIcon.9c197b1546963394e4b4e43a5dd45699.svg";
export { ForwardRef as ReactComponent };